import React from "react";
import { NavLink } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { useEffect } from "react";


function Blog() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="blog" className=" pt-32  sm:mx-4 ">
      <div className="text-auto mx-auto mb-16 max-w-full text-center md:w-2/3" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="300" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
        <h1 className=" mb-4 font-mukta text-2xl font-bold text-primary md:text-4xl">
          Blog
        </h1>
        <h2 className="mb-2 text-lg font-semibold text-slate-800">
          Learn and Enhance Your Programming Skills
        </h2>
        <p className="text-sm font-medium text-slate-500 md:text-base">
          Discover helpful guides, tips, and tutorials for web and app
          development in our "Programming" section. Improve your programming
          skills with our valuable resources. Happy learning!
        </p>
      </div>
      <div className="container mx-auto mt-20  w-full sm:flex sm:flex-wrap sm:justify-evenly sm:gap-6">
        <div className="sm:w-50 mb-10 overflow-hidden rounded-lg bg-white shadow-lg sm:mb-0 md:w-80 lg:w-72" data-aos="flip-left" data-aos-duration="1000" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
          <img src="./img/blog1.jpg" alt="Blog 1" className="w-full" />
          <div className="px-6 py-4">
            <div className="mt-6 text-xl font-semibold text-gray-700">
              Advanced Error Handling Techniques for Professional Developers
            </div>
            <p className="mt-4 text-base text-slate-600">
              As software applications grow in complexity and scale, it becomes
              increasingly important for professional developers to implement
              robust error handling.....
            </p>
            <div className="w-full px-4">
              <NavLink to="/artikel2">
                <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                  Read More
                </button>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="sm:w-50 mb-10 overflow-hidden rounded-lg bg-white shadow-lg sm:mb-0 md:w-80 lg:w-72" data-aos="flip-left" data-aos-duration="1000" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
          <img src="./img/blog2.jpg" alt="Blog 2" className="w-full" />
          <div className="px-6 py-4">
            <div className="mt-6 text-xl font-semibold text-gray-700">
              Exploring Modern Web Programming: Popular Frameworks and Tools in
              2023
            </div>
            <p className="mt-4 text-base text-slate-600">
              The field of web development is constantly evolving, with new
              technologies and trends emerging each year....
            </p>
            <div className="w-full px-4">
              <NavLink to="/artikel3">
                <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                  Read More
                </button>
              </NavLink>
            </div>
          </div>
        </div>

        <div className="sm:w-50 mb-10 overflow-hidden rounded-lg bg-white shadow-lg sm:mb-0 md:w-80 lg:w-72" data-aos="flip-left" data-aos-duration="1000" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
          <img src="./img/blog3.jpg" alt="Blog 3" className="w-full" />
          <div className="px-6 py-4">
            <div className="mt-6 text-xl font-semibold text-gray-700">
              Mastering Programming: Tips and Strategies for Success in the
              Digital World
            </div>
            <p className="mt-4 text-base text-slate-600">
              Programming has become an increasingly important skill in today's
              digital era. In the rapidly evolving world of information.....
            </p>
            <div className="w-full px-4">
              <NavLink to="/artikel1">
                <button className="mt-3 inline-block w-full rounded-full bg-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition duration-300 ease-in-out hover:-translate-y-1 hover:bg-cyan-300 hover:shadow-lg">
                  Read More
                </button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Blog;
